import React from "react";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
} from "@coreui/react";
import { DownArrowIcon } from "../../../assets/images";
import NoDataTableItem from "../../../components/AdminDashboard/NoDataTableItem";
import TableItem from "./TableItem";
import { ActionType, IColumnObject } from "./ITable";
import './table.scss';

interface ITableContainerProps {
  tbColumns: IColumnObject[];
  dataList: IColumnObject[][];
  actionsCallback?: (action: ActionType, data: any) => void;
  tableType?: string;
}

const TableContainer = ({
  tbColumns,
  dataList,
  actionsCallback,
  tableType = '',
}: ITableContainerProps) => {
  const sortByLocale = (key: string) => {
    actionsCallback && actionsCallback(ActionType.SORT, key);
  };

  return (
    <CTable className="mt-3 tableContainer" borderless hover>
      <CTableHead className="tableHead">
        <CTableRow>
          {!!tbColumns &&
            tbColumns.length !== 0 &&
            Array.isArray(tbColumns) &&
            tbColumns.map((colNameItem, index) => (
              <CTableHeaderCell
                style={{ width: colNameItem?.width, minWidth: colNameItem?.minWidth, maxWidth: colNameItem?.maxWidth }}
                key={`tableContainer${index}`}
                scope="col"
                className={"clickable"}
                onClick={() => {
                  sortByLocale(`${colNameItem.dbField}`);
                }}
              >
                {colNameItem.displayField}
                <DownArrowIcon height={12} width={12} />
              </CTableHeaderCell>
            ))}
        </CTableRow>
      </CTableHead>
      <CTableBody className="tableBody">
        {!!dataList &&
          dataList.length !== 0 &&
          Array.isArray(dataList) ? (
          dataList.map((dataItem, index) => {
            return (
              <TableItem
                key={`TableItemContainer_${index}`}
                dataItem={dataItem}
                actionsCallback={actionsCallback}
              />
            );
          })
        ) : (
          <NoDataTableItem
            colSpan={10}
            message={`There is no ${tableType} data.`}
          />
        )}
      </CTableBody>
    </CTable>
  );
};

export default TableContainer;
